import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../incidentGrid.scss'
import '../../incidentList.scss'
import LoaderWrapper from '../../common/LoaderWrapper/LoaderWrapper'
import Loading from '../../common/LoaderWrapper/loading'
import Paginator from '../../common/paginator/paginator'
import Tooltip from '../../common/popover/tooltip'
import DetailsPopover from '../../common/popover/detailsPopover'
import ThreatFeedStatusMenu from './ThreatFeedStatusMenu'
import { formatThreatFeedDatetime } from '../../../utilities/datetime'
import { getStatusClass } from '../../../utilities/statusCSSClass'
import { getOSType } from '../../../utilities/OSTypes'
import { loadNextEvents, loadPrevEvents } from '../../../store/entities/events'

// ===========================================================================
// Threat Feed — grid (card) view (PIXMC-6500).
//
// Custom card markup ported from the claude-dashboards mockup: two cards per row, each led
// by the real detection screenshot. Shared events slice, same pagination and Update Status
// wiring as the list — presentation only. Renders inside ThreatFeed's card.
// ===========================================================================

// Status badge colour reuses the shared getStatusClass → Common.scss classes, like the
// legacy Incidents grid.
const userName = (e) => e.osUserId || e.osComputerName || e.osuuid || e.email || 'NA'
const screenshotOf = (e) => e.resizedScreenshotURL || e.screenshotURL || e.markedScreenshotURL || null

// User column reuses the legacy DetailsPopover with the same payload as the legacy grid.
const DeviceType = new Map([['D', 'Desktop'], ['M', 'Mobile']])
const userDetails = (e) => ({
  User: userName(e),
  'User ID': e.osUserId || 'NA',
  Platform: `${getOSType(e.os)}, ${e.browserName}`,
  'Machine ID': e.osuuid || 'NA',
  'Computer Name': e.osComputerName || 'NA',
  Device: e.deviceType ? DeviceType.get(e.deviceType) : 'NA',
})

class ThreatFeedGrid extends Component {
  render() {
    const { events, threatFilters, totalSize, loading, isLastPage, onDetails } = this.props
    const { offset } = threatFilters
    const rows = events.slice(offset, offset + 20)
    // Remount the Paginator on any filter (except offset) change so its cached filters stay
    // fresh — otherwise paging re-sends the previous startTime.
    const pagerKey = [
      threatFilters.startTime, threatFilters.endTime, threatFilters.order,
      threatFilters.brand || '', threatFilters.extensionUserId || '',
      threatFilters.triagedEvent != null ? threatFilters.triagedEvent : '',
      threatFilters.pixmVerified != null ? threatFilters.pixmVerified : '',
      (threatFilters.type || []).join(','),
    ].join('|')

    return (
      <>
        <div className="tfResultsCount">
          Results ({rows.length === 0 ? 0 : isLastPage ? offset + rows.length : `More than ${offset + rows.length}`})
        </div>
        <div className="tfCardBody">
          {/* Loader overlays the grid only (existing Loading component); content stays
              mounted underneath during filter / sort / page loads. */}
          {loading && <div className="tfLoaderOverlay"><Loading loading={true} /></div>}
          <LoaderWrapper
            loading={false}
            data={rows}
            styles={{ minHeight: '400px' }}
            placeholderText={'No Threats Detected'}
          >
            <>
              <div className="tfGrid">
                {rows.map((item, i) => {
                  const shot = screenshotOf(item)
                  return (
                    <div className="tfPcard" key={item.id || i}>
                      {shot ? (
                        <img className="tfPcardShotImg" src={shot} alt={`${item.brands || 'Phishing'} page screenshot`} />
                      ) : (
                        <div className="tfPcardShot">No screenshot</div>
                      )}
                      <div className="tfPcardHead">
                        <div>
                          <DetailsPopover header={userName(item)} data={userDetails(item)} />
                          <div className="tfPcardBrand">{item.brands || 'NA'}</div>
                        </div>
                        <span className={getStatusClass(item.status)}><b>{item.status}</b></span>
                      </div>
                      <div className="tfPcardUrl" data-tip data-for={`grid-${item.url}`}>{item.url}</div>
                      <Tooltip id={`grid-${item.url}`} data={item.url} className="tfTooltipWrap" />
                      <div className="tfPcardOpened">Opened at {formatThreatFeedDatetime(item.detectionTime)}</div>
                      <div className="tfPcardActions">
                        <ThreatFeedStatusMenu event={item} onAction={this.props.onStatusAction} />
                        <button className="tfBtn" onClick={() => onDetails(item)}>View Details</button>
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className="tfPager">
                <Paginator
                  key={pagerKey}
                  onNext={this.props.loadNextEvents}
                  onPrev={this.props.loadPrevEvents}
                  filters={threatFilters}
                  totalSize={totalSize % 21 !== 0 ? events.length : events.length + 1}
                  isLastPage={isLastPage}
                  cacheSize={events.length}
                  from={'incidentGrid'}
                />
              </div>
            </>
          </LoaderWrapper>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  events: state.entities.events.list,
  threatFilters: state.entities.events.threat.filters,
  loading: state.entities.events.loading,
  totalSize: state.entities.events.totalSize,
  isLastPage: state.entities.events.isLastPage,
})

const mapDispatchToProps = (dispatch) => ({
  loadNextEvents: (offset, customerId, defaultCustomerId, isGlobalView) =>
    dispatch(loadNextEvents(offset, customerId, defaultCustomerId, isGlobalView)),
  loadPrevEvents: (offset, customerId, defaultCustomerId, isGlobalView) =>
    dispatch(loadPrevEvents(offset, customerId, defaultCustomerId, isGlobalView)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThreatFeedGrid)
